import { useTranslation } from 'react-i18next';
import { IconPanelAddIllustration, IconPanelIllustration } from '../../../../components/buttons/IconButtons';

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Picks the illustration of the empty state: the "add" one for an empty canvas,
 * the panel one for an unconfigured panel.
 */
const PanelEmptyStateApp = ({ add }) => {
    const { t } = useTranslation();
    const Illustration = add ? IconPanelAddIllustration : IconPanelIllustration;

    return {
        t,
        Illustration
    };
};

export default PanelEmptyStateApp;
